import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/bluesky-scheduler")({
	beforeLoad: () => {
		throw redirect({ to: "/channels/bluesky" });
	},
});
